// The Copilot's own mark (files in public/, made for it): still by default, animated while the AI is thinking.
// Both animated files stop moving by themselves for « reduce motion » (their own prefers-reduced-motion rule).
const SOURCES = {
  still: "copilot-jamora-compact.svg",
  // For the dark sidebar: the navy part of the mark is white there, otherwise it vanishes into the navy background.
  onDark: "copilot-jamora-compact-on-dark.svg",
  thinking: "copilot-jamora-animated-logo-etincelles.svg",
  // Stronger sparkles: still readable at bubble size, where the subtle version disappears.
  thinkingStrong: "copilot-jamora-animated-strong.svg",
};

export default function CopilotLogo({ variant = "still", size = 24, className = "" }) {
  return (
    <img src={`${process.env.PUBLIC_URL}/${SOURCES[variant]}`} width={size} height={size} alt="" aria-hidden="true"
      draggable={false} className={`shrink-0 select-none ${className}`} data-testid={`copilot-logo-${variant}`} />
  );
}
